import {apiClient} from "./api";
import {CACHE_KEYS} from "./constants/cacheKey";
import {groupBy, includes, keys} from 'ramda';
import {cloneDeep} from 'lodash';

/*
HANDLE DATA IN SESSION STORAGE
*/

export function folderConfigurations() {
    apiClient.list('/document-service/api/v2/folders/permissions').then(response => {
        if (!response.error) {
            sessionStorage.setItem(CACHE_KEYS.FOLDERS_PERMISSIONS, JSON.stringify(response['data']));
        }
    }).catch(error => {
        console.error('Cant get folders permissions', error);
    });
}

export function getFoldersWithPermission() {
    const json_permission_folders = sessionStorage.getItem(CACHE_KEYS.FOLDERS_PERMISSIONS);
    let permission_folders = json_permission_folders ? JSON.parse(json_permission_folders) : [];

    if (permission_folders) {
        const resourceId = x => x['resource_id'];
        permission_folders.forEach(folder => {
            if (folder.children) {
                const children = [];
                const uniqueGroups = groupBy(resourceId, folder.children);
                uniqueGroups && keys(uniqueGroups).forEach(group => {
                    if (uniqueGroups[group].length > 1) {
                        const permissions = uniqueGroups[group].map(x => x.permission);
                        const child = uniqueGroups[group][0];
                        child.permission = includes('Document.FullControl', permissions) ? 'Document.FullControl' : 'Document.ReadOnly';
                        children.push(child)
                    } else {
                        children.push(uniqueGroups[group][0]);
                    }
                });
                folder.children = children;
            }
        });
    }

    return permission_folders
}


/* 
HANDLE DATA FROM REDUX STORE PASSED BY PARAM
*/

export function listFoldersAndSubfolders(hierachy, ids?) {
    try {
        const children = []
        let parents = hierachy.filter(f => (f.children || []).filter(s => {
            if (!ids || ids.includes(s.resource_id)) { // id=undefined -> get all
                children.push(s.label)
                return true
            } else {
                return false
            }
        }).length > 0).map(f => f.label)

        // Case default folder
        if (children.length === 0 && parents.length === 0) {
            parents = hierachy.filter(f => {
                if (!ids || ids.includes(f.resource_id)) { // id=undefined -> get all
                    return true
                } else {
                    return false
                }
            }).map(f => f.label)
        }
        return {
            folders: parents,
            subfolders: children
        }
    } catch (error) {
        console.error('Server should return folders and sub-folders. Error: ' + error);
        return {
            folders: [],
            subfolders: []
        }
    }
}

export function filterFoldersHierarchyByPermissionAction(hierachy, permission) {
    return cloneDeep(hierachy)
        .filter(f => f.permission === permission)
        .map(f => {
            f.children = (f.children || []).filter(s => s.permission === permission)
            return f
        })
}

export function findFolderOrSubfolderById(hierachy, id) {
    if (!hierachy) {
        return
    }
    let result
    hierachy.every(f => {
        if (f.resource_id === id) {
            result = f
            return false
        } else {
            result = (f.children || []).find(s => s.resource_id === id)
            if (result) {
                return false
            }
        }
        return true
    })
    return result
}